import { Grid, Stack } from '@mui/material'
import { Field } from 'pages/TeenagersRecord/components/Field'
import React from 'react'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { booleanSimNao, formatBirthdayEN, formatChoiceText, formatText } from 'utils/text.util'

type TabContentProps = {
  data: HearingIdentificationType
}

export const TabProfessionalDataContent: React.FC<TabContentProps> = ({ data }) => {
  return (
    <Grid item xs={12}>
      <Stack direction='column' spacing={2}>
        <Field
          label='Exerce alguma atividade remunerada?'
          value={[formatChoiceText(data.identificacaoAdolescente.exerceAtividadeRemunerada)]}
          direction='row'
        />
        {booleanSimNao(data.identificacaoAdolescente.exerceAtividadeRemunerada) && (
          <>
            <Field
              label='Valor da remuneração:'
              value={[formatText(data.identificacaoAdolescente.descricaoValorRemuneracao)]}
              direction='row'
            />
            <Field
              label='Atividade:'
              value={[formatText(data.identificacaoAdolescente.descricaoAtividadeRemunerada)]}
              direction='row'
            />
          </>
        )}
        <Field
          label='Inserido no Jovem Aprendiz?'
          value={[formatChoiceText(data.identificacaoAdolescente.inseridoJovemAprendiz)]}
          direction='row'
        />

        {booleanSimNao(data.identificacaoAdolescente.inseridoJovemAprendiz) && (
          <>
            <Field
              label='Data de Inicio'
              value={[formatBirthdayEN(data.identificacaoAdolescente.dataInicioJovemAprendiz)]}
              direction='row'
            />
            <Field
              label='Empresa:'
              value={[formatText(data.identificacaoAdolescente.empresaJovemAprendiz)]}
              direction='row'
            />
            <Field
              label='Contato:'
              value={[formatText(data.identificacaoAdolescente.contatoJovemAprendiz)]}
              direction='row'
            />
            <Field
              label='Turno:'
              value={[formatText(data.identificacaoAdolescente.turnoJovemAprendiz)]}
              direction='row'
            />
            <Field
              label='Apresenta Interesse?'
              value={[
                formatChoiceText(data.identificacaoAdolescente.apresentaAreaInteresseJovemAprendiz),
              ]}
              direction='row'
            />
            {booleanSimNao(data.identificacaoAdolescente.apresentaAreaInteresseJovemAprendiz) && (
              <>
                <Field
                  label='Objetivo'
                  value={[
                    formatText(data.identificacaoAdolescente.objetivoAreaInteresseJovemAprendiz),
                  ]}
                  direction='row'
                />
              </>
            )}
            {!booleanSimNao(data.identificacaoAdolescente.apresentaAreaInteresseJovemAprendiz) && (
              <>
                <Field
                  label='Motivo'
                  value={[formatText(data.identificacaoAdolescente.motivoNaoAdesaoJovemAprendiz)]}
                  direction='row'
                />
                <Field
                  label='Motivo Não Adesão'
                  value={[formatText(data.identificacaoAdolescente.motivoNaoInseridoJovemAprendiz)]}
                  direction='row'
                />
              </>
            )}
          </>
        )}
      </Stack>
    </Grid>
  )
}
